import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { LIST } from "constants/index"
import { wishItemActions } from "constants/options"
import { SWITCH_LIST_ITEM_VIEW_MODE } from "constants/events"
import { isListEmpty } from "utils/componentsUtils"
import { updateCurrentPageInfo, updateSearchedUserIsLoggedInUser } from "appRedux/slices/globalSlice"
import { updateWishListViewMode } from "appRedux/slices/wishListSlice"
import { useAppSelector } from "appRedux/hooks"
import WishListPageTemplate from "components/templates/WishListPageTemplate"
import { getHeaderButtons } from "components/templates/WishListPageTemplate/_utils"

export default function WishListPage() {
  const wishListState = useAppSelector((state) => state.wishList)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateSearchedUserIsLoggedInUser(false))
  }, [])

  useEffect(() => {
    dispatch(updateCurrentPageInfo({
      title: wishListState?.listInfo?.name || "",
      headerButtons: getHeaderButtons(wishListState.listInfo, wishListState.viewMode),
      customBackButtonEvent: wishListState.viewMode === LIST ? null : SWITCH_LIST_ITEM_VIEW_MODE,
      useLayoutWithPadding: wishListState.viewMode === LIST
    }))
  }, [JSON.stringify(wishListState)])

  useEffect(() => {
    if (wishListState?.listInfo?.listItems === null || wishListState?.listInfo?.listItems?.length === 0) {
      dispatch(updateWishListViewMode(LIST))
    }
  }, [JSON.stringify(wishListState?.listInfo?.listItems)])

  return (
    <WishListPageTemplate
      moreButtonActions={wishItemActions}
      listIsEmpty={isListEmpty(wishListState.listInfo)}
    />
  )
}
